var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.shopTitle))]),_c('h2',{staticClass:"text-center"},[_vm._v("Verkäufer-Portal")]),_c('section',{attrs:{"id":"firebaseui-auth-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }